<style lang="scss" scoped>
@import '../css/sub.scss';
@import '../css/admin.scss';
</style>
<template>
  <div class="donga-audit">
    <header class="audit-header">
      <nav class="audit-nav">
        <div class="nav-container">
          <h1 class="logo">
            <a href="/adminlogin">동아쏘시오 그룹 사이버감사실</a>
          </h1>
        </div>
      </nav>
    </header>
    <div class="audit-template login-template">
      <div class="login-area">
        <div class="logo">
            <img src="../img/admin-login-logo.png" alt="동아쏘시오그룹 사이버 감사실">
        </div>
        <form @submit.prevent="submit">
        <div class="form-group-container">
          <h2 class="tit">로그인</h2>
          <div class="form-group" :class="{ 'form-group-error': $v.adminUser.$error }">
            <div class="input-area">
              <label class="blind" for="admin-id">아이디</label>
              <input
                class="default-input"
                type="text"
                v-model.trim="$v.adminUser.$model"
                id="admin-id"
                placeholder="아이디"
                readonly
                >
            </div>
            <p class="error" v-if="!$v.adminUser.required">아이디를 입력해주세요.</p>
          </div>
          <div class="form-group" :class="{ 'form-group-error': $v.adminPassword.$error }">
            <div class="input-area">
              <label class="blind" for="admin-password">패스워드</label>
              <input
                class="default-input"
                type="password"
                v-model.trim="$v.adminPassword.$model"
                id="admin-password"
                placeholder="패스워드">
            </div>
            <p class="error" v-if="!$v.adminPassword.required">패스워드를 입력해주세요.</p>
          </div>
          <button class="default-btn" type="submit">로그인</button>
          </div>
        </form>
      </div>
    </div>
    <audit-footer></audit-footer>
  </div>
</template>

<script>
import AuditFooter from '@/components/AuditFooter'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'AdminLogin',
  components: {
    'audit-footer': AuditFooter
  },
  data () {
    return {
      adminUser: '',
      adminPassword: ''
    }
  },
  mounted () {
    this.adminUser = atob(this.$route.query.userId)
  },
  validations: {
    adminUser: {
      required
    },
    adminPassword: {
      required
    }
  },
  methods: {
    submit () {
      const params = {
        loginId: this.adminUser,
        password: this.adminPassword,
        timestamp: Math.floor(+new Date() / 1000)
      }
      this.$v.$touch()
      if (this.$v.$invalid) {
      } else {
        this.$store.dispatch('apiAdminSignin', params)
      }
    }
  }
}

</script>

<style lang="scss" scoped>
html, body, #app{
  height:100%;
}
.admin-template{
  background:#f3f3f3;
}
.login-area{
  width:690px;
  margin:190px auto 0;
  padding-bottom:190px;
  .logo{
    text-align:center;
  }
  .default-btn{
    margin-top:30px;
    width:100%;
    background:#000;
  }
  .form-group-container{
    border-top:none;
    margin-top:20px;
    padding:0;
    border-bottom:none;
    background:#fff;
    padding:60px 90px 110px 90px;
    .tit{
      font-size:59px;
      text-align:center;
      line-height:1;
      margin-bottom:50px;
    }
    .form-group{
      padding-top:15px;
    }
    .error{
      margin-left:0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AdminLogin.vue